<template>
  <ValidationProvider
    name="contract_type"
    ref="provider"
    rules="oneOf:1,2,3"
    v-slot="{ errors, validate }"
  >
    <v-radio-group
      v-model="contract_type"
      @change="validate"
      :error-messages="errors"
    >
      <v-radio value="1" label="Двусторонний договор"></v-radio>
      <v-card flat v-if="contract_type === '1'">
        <v-card-text>
          <p>
            Будет оформлен оператором по информации из раздела &laquo;Персональные данные&raquo; личного
            кабинета.
          </p>
          <p>Сформированные документы по оплате и форма заявления о согласии на зачисление по контракту будут переданы
            вам через страницу просмотра заявления для дальнейшего заполнения.</p>
        </v-card-text>
      </v-card>


      <v-radio value="2" label="Трехсторонний договор с физическим лицом"></v-radio>
      <v-card flat v-if="contract_type === '2'">
        <v-card-text>

          <ol>
            <li class="mb-2">
              <a class="font-weight-regular indigo--text"
                 v-bind:href="'/files/app/Договор_(доп_информация_3х_фл).pdf'"
                 target="_blank"
              >Скачайте</a>
              и распечатайте бланк с информацией для подготовки договора.
            </li>
            <li class="my-2">
              Заполните
              <v-tooltip bottom max-width="600">
                <template v-slot:activator="{ on, attrs }">
                  <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">собственноручно</span>
                </template>
                <span>
                      Заполняется рукописным способом разборчиво (печатными буквами) чернилами черного либо синего цвета.
                      Опечатки, подчистки, приписки, зачеркнутые слова и иные исправления не допускаются.
                    </span>
              </v-tooltip>
              все поля и заверьте документ личной подписью с расшифровкой.
            </li>
            <li>Создайте
              <v-tooltip bottom max-width="600">
                <template v-slot:activator="{ on, attrs }">
                  <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                </template>
                Фотография с телефона или скан-копия документа.
                Качество изображений должно обеспечивать читаемость информации.
                Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.
              </v-tooltip>
              документа и прикрепите в поле "Выбрать файл".
            </li>
          </ol>

          <file-input
            ref="type101Files"
            :type="101"
            :application="application"
            :max-files="1"
          ></file-input>

          <ol start="4">
            <li>Создайте
              <v-tooltip bottom max-width="600">
                <template v-slot:activator="{ on, attrs }">
                  <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                </template>
                Фотография с телефона или скан-копия документа.
                Качество изображений должно обеспечивать читаемость информации.
                Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.
              </v-tooltip>
              паспорта Заказчика (включая сведения о регистрации) и прикрепите в поле "Выбрать файл".
            </li>
          </ol>

          <file-input
            ref="type102Files"
            :type="102"
            :application="application"
            :max-files="5"
          ></file-input>
          <p>Сформированные документы по оплате и форма заявления о согласии на зачисление по контракту будут переданы
            вам через страницу просмотра заявления для дальнейшего заполнения.</p>
        </v-card-text>
      </v-card>


      <v-radio value="3" label="Трехсторонний договор с юридическим лицом"></v-radio>
      <v-card flat v-if="contract_type === '3'">
        <v-card-text>
          Создайте
          <v-tooltip bottom max-width="600">
            <template v-slot:activator="{ on, attrs }">
              <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed"
                    v-on="on">электронную копию</span>
            </template>
            Фотография с телефона или скан-копия документа.
            Качество изображений должно обеспечивать читаемость информации.
            Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.
          </v-tooltip>
          документа, содержащего адрес и банковские реквизиты заказчика
          (в свободной форме) и прикрепите в поле "Выбрать файл"
          <file-input
            ref="type103Files"
            :type="103"
            :application="application"
            :max-files="1"
          ></file-input>
          <p>Сформированные документы по оплате и форма заявления о согласии на зачисление по контракту будут переданы
            вам через страницу просмотра заявления для дальнейшего заполнения.</p>
        </v-card-text>
      </v-card>
    </v-radio-group>
  </ValidationProvider>
</template>

<script>
  import {mapGetters} from "vuex";
  import {extend, localize, ValidationProvider} from "vee-validate";
  import {oneOf} from "vee-validate/dist/rules";
  import FileInput from "../../FileInput";

  export default {
    name: "ContractTypeRadio",
    components: {
      FileInput,
      ValidationProvider
    },
    data() {
      return {
        isSuccess: false,
      }
    },
    watch: {
      contract_type() {
        this.$refs.provider.reset()
        if (this.$refs.type101Files) {
          this.$refs.type101Files.$refs.provider.reset()
        }
        if (this.$refs.type102Files) {
          this.$refs.type102Files.$refs.provider.reset()
        }
        if (this.$refs.type103Files) {
          this.$refs.type103Files.$refs.provider.reset()
        }
      }
    },
    computed: {
      ...mapGetters("application", ["application"]),
      contract_type: {
        get() {
          return String(this.application.contract_type_id)
        },
        set(value) {
          this.$store.commit("application/CHANGE_APPLICATION", {contract_type_id: value})
          this.$store.dispatch("application/updateApplication")
        }
      },
    },
    methods: {
      async submit() {
        const {valid} = await this.$refs.provider.validate(this.contract_type);
        if (valid) {
          this.isSuccess = true
        }
      }
    }
  }

  localize({
    ru: {
      names: {
        contract_type: " "
      }
    }
  });

  extend("oneOf", {
    ...oneOf
  });
</script>
